var styles = {
raw: ".hcr-overlay-13-6-1{background:var(--hcr-overlay-bg-color);height:100%;left:0;position:fixed;top:0;width:100%;z-index:1100}",
map:{"hcr-overlay":"hcr-overlay-13-6-1"}};

export { styles as default };
